import React from 'react'
import {FormattedMessage} from 'react-intl'
import {AspectRatio, Stack, GridProps, HStack, Image, Link, LinkProps, SimpleGrid, useMultiStyleConfig, StackProps} from '@chakra-ui/react'
import {StorySuggestion} from '_types'

interface StoriesGridProps {
    stories: Array<StorySuggestion>
}

/**
 * @name StoriesGrid
 *
 * @component
 *
 * @description
 * Renders a grid containing suggested stories.
 *
 * @param {StoriesGridProps} props - Props object.
 * @param {Array<StorySuggestion>} props.stories - Suggested stories array.
 *
 * @returns {JSX.Element} - Rendered StoriesGrid component.
 */
const StoriesGrid: React.FC<StoriesGridProps> = ({stories}) => {
    const styles = useMultiStyleConfig('StoriesGrid') as Record<string, GridProps & LinkProps & StackProps>

    return (
        <SimpleGrid data-testid="stories-grid" {...styles.grid}>
            {stories.map((story) => (
                <Stack {...styles.story} key={story.name} data-testid="story">
                    <Link href={story.href} data-testid="story-link">
                        <AspectRatio ratio={1.61}>
                            <Image data-testid="story-image" alt={story.image.alt} title={story.name} src={story.image.url} />
                        </AspectRatio>
                    </Link>
                    <HStack {...styles.findOutWrapper}>
                        <Link data-testid="story-find-out-link" {...styles.findOutLink} href={story.href} variant="hoverUnderline">
                            <FormattedMessage id="storiesGrid.findOut" defaultMessage="Scopri" />
                        </Link>
                    </HStack>
                </Stack>
            ))}
        </SimpleGrid>
    )
}

export default StoriesGrid
